import { useEffect, useMemo, useState } from "react";
import api from "../lib/api";
import { Input } from "../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Search } from "lucide-react";
import { PortfolioMatrix } from "../components/PortfolioMatrix";

export default function HotelProgress() {
  const [data, setData] = useState(null);
  const [search, setSearch] = useState("");
  const [cluster, setCluster] = useState("all");

  useEffect(() => { api.get("/dashboard/portfolio-matrix").then((r) => setData(r.data)); }, []);

  const clusters = useMemo(() => [...new Set((data?.rows || []).map((r) => r.cluster).filter(Boolean))].sort(), [data]);
  const q = search.toLowerCase();
  const rows = (data?.rows || []).filter((r) =>
    (cluster === "all" || r.cluster === cluster) &&
    (!q || [r.hotel, r.cluster].some((v) => (v || "").toLowerCase().includes(q))));

  return (
    <div className="max-w-7xl mx-auto space-y-6" data-testid="hotel-progress-page">
      <div>
        <h1 className="text-3xl font-extrabold tracking-tight text-stone-900">Hotel Progress</h1>
        <p className="text-stone-500 mt-1 text-sm">Every hotel's last score per audit — <span className="text-rose-600 font-semibold">red cells</span> have a missed/overdue audit. Average and completion at the end of each row.</p>
      </div>

      <div className="flex flex-wrap items-center gap-3">
        <div className="relative max-w-sm flex-1 min-w-[220px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" />
          <Input data-testid="progress-search-input" className="pl-9 bg-white" placeholder="Search hotel or cluster..." value={search} onChange={(e) => setSearch(e.target.value)} />
        </div>
        <Select value={cluster} onValueChange={setCluster}>
          <SelectTrigger className="w-44 h-10 text-sm bg-white" data-testid="progress-cluster-filter"><SelectValue placeholder="Cluster" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All clusters</SelectItem>
            {clusters.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
          </SelectContent>
        </Select>
        {data && <span className="text-xs text-stone-400">{rows.length} of {data.rows.length} hotels</span>}
      </div>

      {data ? (
        <div className="bg-white border border-[#E7E5DF] rounded-xl p-4">
          <PortfolioMatrix templates={data.templates} rows={rows} testId="progress-matrix" />
        </div>
      ) : (
        <div className="flex justify-center py-24"><div className="w-8 h-8 border-2 border-[#14532D] border-t-transparent rounded-full animate-spin" /></div>
      )}
    </div>
  );
}
